import React from 'react';
 import useScrollToTop from '../components/useScrollToTop';
 import Button from '../components/Button';
 import './floorpages.css';
 import threeDPlan1 from '../img/floor_plan_5.avif'; // Replace with relevant image - use content_id: http://googleusercontent.com/image_generation_content/0
 import threeDCourtyard from '../img/floor_plan1.avif'; // Replace with relevant image - use content_id: http://googleusercontent.com/image_generation_content/1
 import threeDFurniture from '../img/hall_img_1.avif'; // Replace with relevant image - use content_id: http://googleusercontent.com/image_generation_content/2
 import threeDExterior from '../img/elevation_img_19.avif'; // Replace with relevant image - use content_id: http://googleusercontent.com/image_generation_content/3

 const PageHomeNaksha3D = () => {
  useScrollToTop();

  return (
    <>
    <div className='project-container'>
  <div className="project-details">
  <h1 className="">Visualize Your Dream Home in Patna: Explore House Plans in 3D</h1>

  <section className="">
  <h2 className=" ">Step Inside Your Future Home Before It's Built</h2>
  <p className="project-intro-text">
  Our 3D home nakshas provide a realistic and immersive visualization of our house plans, allowing you to understand the spatial flow, light, and overall feel of your potential residence in Patna. See your dream home come to life before construction begins!
  </p>
  </section>

  <section className="">
  <h2 className=" ">The Power of 3D Visualization for Patna Homes</h2>
  <ul className="list-items">
  <li>
  <strong>Gain a Clear Understanding of Layout:</strong> See how rooms connect and flow together in a realistic 3D environment.
  <img src={threeDFurniture} alt="3D House Plan Interior Layout in Patna" className="project-image" />
  </li>
  <li>
  <strong>Visualize Furniture Placement:</strong> Plan your interior design and see how your furniture will fit within the space.
  </li>
  <li>
  <strong>Assess Natural Light and Ventilation:</strong> Understand how sunlight will enter your home and how air will circulate.
  </li>
  <li>
  <strong>Identify Potential Design Improvements:</strong> Spot any areas that might need adjustments before construction.
  </li>
  <li>
  <strong>Communicate Your Vision Effectively:</strong> Share your dream home with builders and contractors in a clear and compelling way.
  </li>
  </ul>
  </section>

  <section className="project-content">
  <h2 className="">Explore Our 3D Home Plan Gallery for Patna</h2>
  <ul className="list-items">
  <li>A variety of house plans (across different styles and sizes) rendered in high-quality 3D.</li>
  <li>Multiple views: exterior, interior walkthroughs, and detailed room perspectives.
  <img src={threeDExterior} alt="3D House Plan Exterior in Patna" className="project-image" />
  </li>
  <li>Examples of both modern and traditional home designs suitable for Patna.
  <img src={threeDCourtyard} alt="3D House Plan with Courtyard in Patna" className="project-image" />
  </li>
  <li>Options for different levels of detail and rendering styles.</li>
  </ul>
  </section>

  <section className="">
  <h2 className="">From 2D to 3D: Bring Your Patna Home to Life</h2>
  <p className="">
  We can create 3D models from our standard 2D house plans or even your custom designs for your project in Patna. Experience your future home in stunning detail.
  <img src={threeDPlan1} alt="3D Rendering of a House Plan" className="project-image" />
  </p>
  <ul className="list-items">
  <li>Transform your 2D plans into immersive 3D visualizations.</li>
  <li>See your custom home design in realistic detail.</li>
  <li>Make informed decisions about your home's layout and design.</li>
  </ul>
  </section>
   <div className="">
          <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
            <Button className="button-outlined">वास्तु शास्त्र के अनुसार घर का डिज़ाइन बनवाने के लिए हमसे संपर्क करें!</Button>
          </a>
        </div>
  </div>
  </div>
  </>
  );
 };

 export default PageHomeNaksha3D;